import {CardLinkWrapper} from '@hconnect/uikit/src/lib2'
import {SxProps, Theme} from '@mui/material'
import {WorkOrdersSummaryContainer} from '@widgets/work-orders'

type Props = {
  plantId: string
  cardBoxSx?: SxProps<Theme>
  cockpitWorkOrdersHref?: string
}

export const WorkOrdersContainer = ({plantId, cardBoxSx, cockpitWorkOrdersHref}: Props) => {
  return (
    <CardLinkWrapper
      href={cockpitWorkOrdersHref}
      data-test-id="work-order-summary-card-link-to-cockpit"
    >
      <WorkOrdersSummaryContainer plantId={plantId} cardBoxSx={cardBoxSx} />
    </CardLinkWrapper>
  )
}
